/**
 * File d'attente des validations d'etapes.
 * Le technicien valide, l'ecran avance immediatement,
 * l'envoi se fait en arriere-plan avec reessai automatique.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const BASE = 'eco_etapes';
const TABLE = 'attente';

let abonnes = [];
let enCours = false;

const ouvrir = () =>
  new Promise((res, rej) => {
    const r = indexedDB.open(BASE, 1);
    r.onupgradeneeded = () => {
      const db = r.result;
      if (!db.objectStoreNames.contains(TABLE)) {
        db.createObjectStore(TABLE, { keyPath: 'id' });
      }
    };
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });

const tx = async (mode, action) => {
  const db = await ouvrir();
  return new Promise((res, rej) => {
    const t = db.transaction(TABLE, mode);
    const s = t.objectStore(TABLE);
    const req = action(s);
    t.oncomplete = () => res(req?.result);
    t.onerror = () => rej(t.error);
  });
};

const prevenir = () => abonnes.forEach((f) => { try { f(); } catch (e) {} });

export const surChangement = (fn) => {
  abonnes.push(fn);
  return () => { abonnes = abonnes.filter((f) => f !== fn); };
};

export const listerEnAttente = async () => {
  try {
    const liste = await tx('readonly', (s) => s.getAll());
    return (liste || []).sort((a, b) => a.date - b.date);
  } catch (e) {
    return [];
  }
};

export const ajouterEtape = async (chantierId, etape) => {
  const item = { id: `${chantierId}_${etape}_${Date.now()}`, chantierId, etape, date: Date.now() };
  await tx('readwrite', (s) => s.put(item));
  prevenir();
  lancerEnvoi();
  return item;
};

export const lancerEnvoi = async () => {
  if (enCours) return;
  enCours = true;
  try {
    let liste = await listerEnAttente();
    while (liste.length) {
      const item = liste[0];
      try {
        await axios.put(`${API}/api/chantiers/mes/${item.chantierId}/etape`, { etape: item.etape }, { timeout: 20000 });
        await tx('readwrite', (s) => s.delete(item.id));
        prevenir();
      } catch (e) {
        const code = e.response?.status;
        if ([400, 403, 404].includes(code)) {
          await tx('readwrite', (s) => s.delete(item.id));
          prevenir();
        } else {
          break;
        }
      }
      liste = await listerEnAttente();
    }
  } finally {
    enCours = false;
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener('online', lancerEnvoi);
  setInterval(lancerEnvoi, 15000);
  lancerEnvoi();
}
